export default "__VITE_ASSET__CWzRvUVg__"